var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('v-container',[_c('h2',[_c('v-icon',{staticClass:"mr-2"},[_vm._v("mdi-calendar")]),_vm._v("Mes réservations à venir")],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }